module.exports = __webpack_public_path__ + "img/courtroom_button.b524cf62.jpg";